// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 36) return "static/js/f5c04f8b76dc5fa74596.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"b3a655d57397c28663e0","139":"dfc1116c8f1099d0dcec","140":"9d049f6f342210267f10"}[chunkId] + ".chunk.js";
};